<template>
  <section
    class="teacher-signup signup"
    :style="{
      'background-image':
        'url(' + bucketUrl + '/assets/background_landing-page.jpg)'
    }"
  >
    <header-logged-out type="teacher" :checkuser="false" />
    <v-container fill-height>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="11" xl="5">
          <v-expand-transition>
            <v-card style="transition: 2s linear 1s;">
              <form @submit.prevent="submit">
                <v-toolbar dark color="primary" flat>
                  <v-toolbar-title>Support Query</v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <div>
                    Have a question or having a problem with the platform? Send
                    us a support query and we’ll help you out.<br /><br />
                    Your request will be forwarded to Kimberlin Education, who
                    manages this platform. We will endeavour to respond to your
                    query within 2 business days.
                  </div>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-2 sm:pr-0">
                      <v-text-field
                        v-model="first_name"
                        :error-messages="errors.collect('first_name')"
                        v-validate="'required|min:2|max:150'"
                        label="First Name"
                        data-vv-name="first_name"
                        data-vv-as="first_name"
                        required
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="pl-2 sm:pl-0">
                      <v-text-field
                        v-model="last_name"
                        v-validate="'required|min:2|max:150'"
                        :error-messages="errors.collect('last_name')"
                        label="Last Name"
                        data-vv-name="last_name"
                        data-vv-as="last_name"
                        required
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="email"
                        v-validate="'required|min:2|email|max:150'"
                        :error-messages="
                          errors.collect('email').concat(errorEmail)
                        "
                        label="E-mail"
                        data-vv-name="email"
                        data-vv-as="email"
                        required
                        @change="errorEmail = []"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="phone"
                        v-validate="'required|min:5|max:150'"
                        :error-messages="errors.collect('phone')"
                        label="Phone Number"
                        data-vv-name="phone"
                        data-vv-as="phone"
                        required
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        ref="question_type"
                        name="question_type"
                        v-model="question_type"
                        v-validate="'required'"
                        :error-messages="errors.collect('question_type')"
                        data-vv-name="question_type"
                        data-vv-as="query type"
                        :items="questions"
                        label="Query type"
                        placeholder="What does your query relate to?"
                        required
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="message"
                        v-validate="'required|min:2|max:500'"
                        counter="500"
                        :error-messages="errors.collect('message')"
                        label="Message"
                        data-vv-name="message"
                        data-vv-as="message"
                        placeholder="Explain the query or issue you are experiencing. The more detail you can give us, the better! Include the device and web browser you are using."
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <file-upload-input
                        ref="file"
                        label="Attachments "
                        placeholder="Upload a screenshot to help us see what the issue is"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="px-3 pb-3 pt-0">
                  <div>
                    Already have an account?
                    <router-link to="/teacher/login" style="color: #1565c0">
                      Click here to log in.
                    </router-link>
                  </div>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    type="submit"
                    :loading="loading"
                    :disabled="loading"
                  >
                    Submit
                  </v-btn>
                </v-card-actions>
              </form>
            </v-card>
          </v-expand-transition>
        </v-col>
      </v-row>
      <custom-snackbar />
    </v-container>
  </section>
</template>

<script>
import { _constants } from 'crypto'
import { mapMutations, mapState } from 'vuex'
import CustomSnackbar from '@/components/snackbar/snackbar'
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import Teacher from '@/modules/teacher/models/Teacher'
import Config from '@/modules/config/models/Config'

export default {
  name: 'LoggedOutSupport',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    CustomSnackbar,
    HeaderLoggedOut,
    FileUploadInput: () => import('@/components/FileUploadInput')
  },
  computed: {
    ...mapState(['bucketUrl']),
    questions() {
      return [
        {
          text: 'General',
          value: 'general'
        },
        {
          text: 'Class',
          value: 'class'
        },
        {
          text: 'Workshop',
          value: 'workshop'
        },
        {
          text: 'View results and graphs',
          value: 'marks_graphs'
        },
        {
          text: 'Other',
          value: 'other'
        }
      ]
    },
    title() {
      return Config.value('title')
    }
  },
  data() {
    return {
      first_name: null,
      last_name: null,
      roleInfo: null,
      question_type: null,
      phone: null,
      message: null,
      email: null,
      errorEmail: [],
      visible: false,
      loading: false
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async submit() {
      // validate form
      let result = await this.$validator.validateAll()
      if (!result) return

      try {
        let form = {
          first_name: this.first_name.toLowerCase(),
          last_name: this.last_name.toLowerCase(),
          email: this.email.toLowerCase(),
          phone: this.phone.toLowerCase(),
          message: this.message.toLowerCase(),
          question_type: this.question_type.toLowerCase(),
          attachment: this.$refs.file.fileList
        }

        this.loading = true
        await Teacher.dispatch('sendSupportMessage', {
          payload: form
        })

        this.showSnackbar('Your message has been sent.')
        this.loading = false

        setTimeout(() => {
          this.$router.push('/teacher/support-message-confirmation')
        }, 2500)
      } catch (error) {
        let status = error.response.status
        this.loading = false
        if (status === 422) {
          if (error.response.data.errors.email) {
            this.errorEmail.push(error.data.errors.email)
            this.showErrorSnackbar('One of the fields could not be validated')
          }
          this.showErrorSnackbar('One of the fields could not be validated')
          return
        }
        let errorMessage = `There was a server error. Contact support.\n ${error.message}: ${error.response.data.message}`
        this.showErrorSnackbar(errorMessage)
      }
    }
  }
}
</script>

<style lang="scss">
.teacher-signup {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
}
</style>
